/**
 * 临时排查工具：捕获「WS 已收到数据但页面未渲染」的偶现现场。
 * 仅非生产环境生效。所有埋点写入 window.__COSMO_WS_TRACE__ 环形缓冲（上限 500 条），
 * 复现问题后在 Console 执行 copy(__COSMO_WS_TRACE_DUMP__()) 即可导出完整时序。
 */
const MAX_ENTRIES = 500
const TRACE_KEY = '__COSMO_WS_TRACE__'
const DUMP_KEY = '__COSMO_WS_TRACE_DUMP__'
const ENABLED = process.env.NODE_ENV !== 'production'

function getBuffer() {
  if (typeof window === 'undefined') return null
  if (!window[TRACE_KEY]) {
    window[TRACE_KEY] = []
    window[DUMP_KEY] = () => JSON.stringify(window[TRACE_KEY], null, 2)
    window.__COSMO_WS_DRIFT_SNAPSHOT__ = () =>
      window.sessionStorage.getItem('COSMO_WS_DRIFT_SNAPSHOT')
    // eslint-disable-next-line no-console
    console.info(
      '[SALE-WS-DEBUG] trace 已开启：复现问题后执行 copy(__COSMO_WS_TRACE_DUMP__()) 导出'
    )
  }
  return window[TRACE_KEY]
}

function push(scope, tag, data) {
  if (!ENABLED) return
  const entry = {
    t: Date.now(),
    time: new Date().toISOString(),
    scope,
    tag,
    data
  }
  const buf = getBuffer()
  if (buf) {
    buf.push(entry)
    if (buf.length > MAX_ENTRIES) buf.splice(0, buf.length - MAX_ENTRIES)
  }
  const prefix = scope === 'drift' ? '[SALE-WS-DRIFT]' : '[SALE-WS-DEBUG]'
  // eslint-disable-next-line no-console
  const log = scope === 'drift' ? console.error : console.log
  log(`${prefix} ${tag}`, data)
}

/** 普通埋点：写入 trace 缓冲 + 打印 */
export function wsTrace(tag, data) {
  push('debug', tag, data)
}

const driftLastAt = {}

/**
 * 漂移告警：store.currentAgentId 与 WS 实际路由 agentId 不一致，
 * 或属于当前会话的内容被写入其它 agent 的数据桶（正是「有数据不渲染」的现场）。
 * 同类告警 2s 内只打一次，避免流式事件刷屏；首次触发附带调用栈。
 */
export function wsDrift(key, data) {
  if (!ENABLED) return
  const now = Date.now()
  if (driftLastAt[key] && now - driftLastAt[key] < 2000) return
  const first = !driftLastAt[key]
  driftLastAt[key] = now
  push('drift', key, {
    ...data,
    stack: first ? new Error().stack : undefined
  })
  // 偶现问题可能伴随刷新：把告警时刻的整条 trace 落到 sessionStorage，刷新后仍可导出
  try {
    window.sessionStorage.setItem(
      'COSMO_WS_DRIFT_SNAPSHOT',
      JSON.stringify({
        key,
        time: new Date().toISOString(),
        data,
        trace: window[TRACE_KEY] || []
      })
    )
  } catch (e) {
    // 忽略存储失败（隐私模式/超限）
  }
}
